import { INavigationMenu } from 'interfaces/navigationMenu.interface'

export type InfluenzaEpidemiologySlugs =
  | 'epidemiology-across-respiratory-diseases'
  | 'strain-circulation'
  | 'case-rate-intensity'
  | 'us-severity'
  | 'research-briefs'
  | 'cases'

const InfluenzaEpidemiologyMenu: Array<
  INavigationMenu<InfluenzaEpidemiologySlugs>[]
> = [
  [
    {
      title: 'Epidemiology across Respiratory Diseases',
      slug: 'epidemiology-across-respiratory-diseases',
      createdAt: new Date(2025, 7, 26),
    },
    {
      title: 'Cases',
      slug: 'cases',
      createdAt: new Date(2025, 7, 26),
    },
    {
      title: 'Strain Circulation',
      slug: 'strain-circulation',
      createdAt: new Date(2022, 5, 10),
    },
    {
      title: 'US Severity',
      slug: 'us-severity',
      createdAt: new Date(2022, 8, 1),
    },
    {
      title: 'Research Briefs',
      slug: 'research-briefs',
      createdAt: new Date(2024, 1, 25),
    },
  ],
]

export { InfluenzaEpidemiologyMenu }
